var map = {
	"./cagayan-cert.webp": 1958,
	"./cert-bg.webp": 1959,
	"./isle-cert.webp": 1960,
	"./license-bg-cn.webp": 1961,
	"./license-bg-mobile-cn.webp": 1962,
	"./license-bg-mobile.webp": 1963,
	"./license-bg.webp": 1964,
	"./pagcor-cert.webp": 1965,
	"./page-bg.webp": 1966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;